export default __webpack_public_path__ + "static/media/gail.9ee77c9c.jpg";